import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { MdrSecurityTelemetryExclusionsWebComponentSchema } from '../types';
import { MdrSecurityTelemetryExclusionsGridDataProviderFactory } from '../factory/MdrSecurityTelemetryExclusionsGridDataProviderFactory';
import { MdrSecurityTelemetryExclusionsGridDataProvider } from '../dataProvider/MdrSecurityTelemetryExclusionsGridDataProvider';

export class MdrSecurityTelemetryExclusionsGridRepository extends BaseWebComponentRepository {
  public dataProviderFactory: MdrSecurityTelemetryExclusionsGridDataProviderFactory;
  public dataProvider: MdrSecurityTelemetryExclusionsGridDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new MdrSecurityTelemetryExclusionsGridDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<MdrSecurityTelemetryExclusionsWebComponentSchema> {
    return this.dataProvider.getDataForView();
  }
}
